// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_OverviewInfoCards_infoBoxContainer__PelVI {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
  gap: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/containers/OverviewInfoCards/OverviewInfoCards.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".infoBoxContainer {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoBoxContainer": `storage_OverviewInfoCards_infoBoxContainer__PelVI`
};
export default ___CSS_LOADER_EXPORT___;
